import { Context, State, Transition } from '../model';

export const setState = (state: Partial<State>): Transition =>
  // eslint-disable-next-line require-yield
  function*(context: Context) {
    context.state = { ...context.state, ...state };
  };
